<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

body{
  margin: 0px;
  padding: 0px;
  /* min-width: 1200px; */
  font-family: "HarmonyOS_Sans_SC_Regular";
}

</style>



// WEBPACK FOOTER //
// src/App.vue